import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const destinationTermsPages: ResourceProps = {
  name: Resource.DESTINATIONS_TERMS,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Destinations Terms",
  },
};

export default destinationTermsPages;
